import {LAYERS_ID} from './constants';
import {GeoJsonLayer, IconLayer} from '@deck.gl/layers';
import {BaseLayerGeoJSONDeck} from '../../../common/layers/baseLayerGeoJSONDeck';

export class StartingLayer extends BaseLayerGeoJSONDeck {
    layers = {
        [this.id]: (
            new GeoJsonLayer({
                id: this.id,
                pickable: true,
                getWidth: _ => 22,
                lineWidthMinPixels: 3,
                renderSubLayers: props => new IconLayer({
                    ...props,
                    id: props.id + this.id,
                    getPosition: d => d.geometry.coordinates,
                    getSize: f => 22,
                    getIcon: f => {
                        return {
                            url: `/assets/cartografia/marker-${this.id === LAYERS_ID.DESTINATION_INFORMO_LAYER ? 'goal' : 'origin'}.png`,
                            height: 22,
                            width: 22
                        };
                    },
                }),
            })
        ),
    };

    constructor(id = LAYERS_ID.STARTING_INFORMO_LAYER) {
        super(id);
    }

    update(id, data) {
        return super.update(
            this.id,
            {data: data || this.getEmptySource()}
            )
            .then(layer => this.layers[this.id] = layer);
    }

}



// WEBPACK FOOTER //
// ./src/app/cities/informo/layers/startingLayer.ts